/*
 *  P01CREALOGCOL18n.js
 *
 *  Created by Sébastien Hecart on 2017-12-19 15:48:07 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  P01CREALOGCOL_description_installation: "Description de l'installation",
  P01CREALOGCOL_in_nombreBatiment: 'Nombre de bâtiments raccordés à la chaufferie ?',
  P01CREALOGCOL_in_nbProductionECS: 'Nombre de production ECS raccordées à la chaufferie ?	',
  P01CREALOGCOL_methode_souhaite: 'Méthode de calcul souhaitée',
  P01CREALOGCOL_description_generateur: 'Nombre de générateurs souhaités',
  P01CREALOGCOL_compilation_uuid: 'Quelle type de somme souhaitez-vous faire ',
  P01CREALOGCOL_in_percentECS: 'ECS',
  P01CREALOGCOL_in_percentChauffage: 'SnP',
  P01CREALOGCOL_nb_generateur: 'Combien de générateur souhaitez-vous ?',
  P01CREALOGCOL_surpuissance_picker: 'Voulez-vous assurer une surpuissance par générateur ?',
  P01CREALOGCOL_surpuissance_percent_picker: 'si oui : ',
  P01CREALOGCOL_compilation_somme_0: '100% chauffage + 100% ECS',
  P01CREALOGCOL_compilation_somme_1: '50% chauffage + 100% ECS',
  P01CREALOGCOL_compilation_somme_2: '75% chauffage + 75% ECS',
  P01CREALOGCOL_compilation_somme_3: '50% chauffage + 50% ECS',
  P01CREALOGCOL_compilation_somme_4: '80% chauffage + 20% ECS',
  P01CREALOGCOL_compilation_somme_5: '100% max(CH;ECS) + 30% min(CH;ECS)',
  P01CREALOGCOL_compilation_somme_6: '120% max(CH;ECS)',
  P01CREALOGCOL_compilation_somme_7: '100% chauffage',
  P01CREALOGCOL_compilation_somme_libre: 'Ratio libre',
  P01CREALOGCOL_surpuissance_0: 'Oui, ECS et Chauffage',
  P01CREALOGCOL_surpuissance_1: 'Oui, ECS seulement',
  P01CREALOGCOL_surpuissance_2: 'Oui, chauffage seulement',
  P01CREALOGCOL_surpuissance_none: 'Non, aucune',
  //page conception
  P01CREALOGCOL_conception_header: 'Renseignez chaque feuille de cacul :',
  P01CREALOGCOL_nom_batiment: 'Nom du bâtiment :',
  P01CREALOGCOL_puissnace_chaufferie: 'Puissance générateur',
  P01CREALOGCOL_production_ecs: 'Production ECS : ',
  P01CREALOGCOL_stockage_primaire: 'Stockage Primaire',
  P01CREALOGCOL_stockage_ecs: 'Stockage ECS',
  P01CREALOGCOL_prim_echangeur: 'Echangeur instantané',
  P01CREALOGCOL_prim_puissance_generateur: 'Puissance générateur',
  P01CREALOGCOL_esc_puissance_echangeur: 'Puissance échangeur',
  P01CREALOGCOL_volume_stockage: 'Volume de Stockage',
  P01CREALOGCOL_todefined: 'Cliquer pour calculer votre production ECS',
  P01CREALOGCOL_stockECS: 'Stockage ECS',
  P01CREALOGCOL_stockPrim: 'Stockage Primaire',
  P01CREALOGCOL_echan_instant: 'Echangeur instantané',
  P01CREALOGCOL_valoume_stock: 'Volume de stockage',
  P01CREALOGCOL_puissance_gen: 'Puissance générateur',
  P01CREALOGCOL_puissance_echan: 'Puissance échangeur',
  P01CREALOGCOL_confirm_delete: 'Etes-vous sur de vouloir supprimer le batiment ?',
  P01CREALOGCOL_confirm_delete_ecs: 'Etes-vous sur de vouloir supprimer la production ECS ?',
  //page resultat
  P01CREALOGCOL_header_result: 'Récapitulatif de votre besoin global',
  P01CREALOGCOL_res_sommeBesoinChauffage: 'Sommes des besoins chaufffage',
  P01CREALOGCOL_res_sommeBesoinECS: 'Somme des besoins ECS',
  P01CREALOGCOL_res_methoChoisie: 'Rappel de la méthode choisie',
  P01CREALOGCOL_in_nbGenerateur: 'Nombre de générateurs',
  P01CREALOGCOL_result_result: 'Résultat',
  P01CREALOGCOL_result_unitair1: 'La production sera composée de ',
  P01CREALOGCOL_result_unitaire2: " générateurs d'une puissance unitaire",
  P01CREALOGCOL_result_typeecs: 'Type ECS',
  P01CREALOGCOL_res_puissanceChaufferie: 'Puissance chaufferie'
}
